import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import withResponsive from "../hoc/withResponsive";
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

class Card extends Component {
  static propTypes = {
    linkTo: PropTypes.string,
    cover: PropTypes.string.isRequired,
    justifyContent: PropTypes.string,
  };

  static defaultProps = {
    linkTo: null,
    cover: null,
    justifyContent: 'space-between',
  };

  render() {
    const { linkTo, cover, children, justifyContent, isMobile, isTablet, ...props } = this.props;
    const Parent = linkTo !== null
      ? props => <StyledLink to={linkTo} {...props} />
      : props => <div {...props} />

    return (
      <Parent {...props}>
        <Container cover={cover} justifyContent={justifyContent} isMobile={isMobile} isTablet={isTablet}>
          {children}
        </Container>
      </Parent>
    );
  }
}

export default withResponsive(Card);

const StyledLink = styled(Link)`
  height: 100%;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justifyContent};
  height: 100%;
  padding: ${themeResponsiveProperty('.625rem', '1rem')};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  color: #fff;

  ${props => props.theme.isMobile && css`
    background-image: linear-gradient(90deg, rgba(0,0,0,.6) 40%, rgba(0,0,0,0) 100%), url("${props => props.cover}");
  `};

  ${props => props.theme.isTablet && css`
    box-shadow: 0 .125rem 1rem rgba(0,0,0,.1);
    background-image: linear-gradient(0deg, rgba(0,0,0,.6) 10%, rgba(0,0,0,0) 40%), url("${props => props.cover}");
  `};
`;
